import script from "./ConsumerProductDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerProductDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerProductDetailView.vue?vue&type=style&index=0&id=932c5d4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932c5d4a"]])

export default __exports__